/* @fflow */
import { fetchGraphql } from 'utils/ajax';

export let LINKS_REQUEST = 'gdc/LINKS_REQUEST';
export let LINKS_SUCCESS = 'gdc/LINKS_SUCCESS';
export let LINKS_FAILURE = 'gdc/LINKS_FAILURE';

function queryLinks({
  id, entity
}, submittedFileTypes, biospecimenFileTypes) {
  let linksQuery = `
    _links {
      id
      type
      ${biospecimenFileTypes.map(d => `...on ${d} { submitter_id }`).join()}
      ${submittedFileTypes.map(d => `...on ${d} { submitter_id }`).join()}
      ...on annotation {
        submitter_id
      }
      ...on diagnosis {
        submitter_id
      }
      ...on treatment {
        submitter_id
      }
    }
  `;

  return {
    variables: { id },
    query: `
      query LinksQuery($id: String) {
        item: ${entity}(id: $id) {
          ${linksQuery}
        }
      }
    `
  };
}

export function fetchLinks(selected, submittedFileTypes, biospecimenFileTypes) {
  return fetchGraphql(
    [{
      type: LINKS_REQUEST,
      meta: { id: selected.id }
    }, {
      type: LINKS_SUCCESS,
      meta: { id: selected.id }
    }, LINKS_FAILURE],
    queryLinks(selected, submittedFileTypes, biospecimenFileTypes)
  );
}

export default function reducer(state = {
  isFetching: false,
  id: '',
  links: []
}, action) {
  switch (action.type) {
  case LINKS_REQUEST:
    return {
      ...state,
      isFetching: true,
      id: action.meta.id,
    };
  case LINKS_SUCCESS:
    return {
      ...state,
      isFetching: false,
      links: action.meta.id === state.id
        ? (action.payload.data.item[0] || {})._links
        : state.links
    };
  case LINKS_FAILURE:
    return {
      ...state,
      isFetching: false
    };
  default:
    return state;
  }
}
